import axios from "axios";

async function blobErrorMessage(data) {
  try {
    const text = typeof data === "string" ? data : await data.text();
    const parsed = JSON.parse(text);
    return parsed?.detail || "Download failed";
  } catch {
    return "Download failed";
  }
}

/**
 * Download an API file (CSV, Excel, PDF) with the user's JWT — plain <a href> cannot send Authorization.
 */
export async function downloadAuthenticatedExport(url, defaultFilename = "export.csv") {
  try {
    const res = await axios.get(url, { responseType: "blob" });
    const contentType = res.headers["content-type"] || "";
    if (res.status >= 400 || contentType.includes("application/json")) {
      throw new Error(await blobErrorMessage(res.data));
    }
    let filename = defaultFilename;
    const disp = res.headers["content-disposition"];
    if (disp) {
      const match = /filename="?([^";\n]+)"?/.exec(disp);
      if (match) filename = match[1];
    }
    const blob = new Blob([res.data], { type: contentType || "application/octet-stream" });
    const objectUrl = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = objectUrl;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    link.remove();
    URL.revokeObjectURL(objectUrl);
  } catch (e) {
    if (e.response?.data instanceof Blob) {
      throw new Error(await blobErrorMessage(e.response.data));
    }
    throw e;
  }
}

export async function openAuthenticatedPdf(url) {
  try {
    const res = await axios.get(url, { responseType: "blob" });
    const contentType = res.headers["content-type"] || "";
    if (res.status >= 400 || contentType.includes("application/json")) {
      throw new Error(await blobErrorMessage(res.data));
    }
    const blob = new Blob([res.data], { type: "application/pdf" });
    const objectUrl = URL.createObjectURL(blob);
    window.open(objectUrl, "_blank", "noopener,noreferrer");
    setTimeout(() => URL.revokeObjectURL(objectUrl), 60000);
  } catch (e) {
    if (e.response?.data instanceof Blob) {
      throw new Error(await blobErrorMessage(e.response.data));
    }
    throw e;
  }
}
